export default __webpack_public_path__ + "static/2161-abf0486106e60ba940cda4640f4475f3.gif";